export { default } from './DiscountTag';
